// Utility to render and print only the installment plan
// Accepts a summary object and an installments array
// summary: { plotNumber, bookingDate, plotSize, totalPrice, initialPayment }
// installments: [{ installment_number, due_date (Date), amount, status }]

export const openInstallmentPlanPrint = (summary, installments) => {
  if (!installments || installments.length === 0) return;

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
      .format(amount || 0)
      .replace("PKR", "Rs")
      .trim();

  const formatDate = (date) => {
    if (!date) return "";
    const d = date instanceof Date ? date : new Date(date);
    if (Number.isNaN(d.getTime())) return "";
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const totalAmount = installments.reduce((sum, inst) => sum + (inst.amount || 0), 0);

  const rows = installments
    .map(
      (inst) => `
      <tr>
        <td>${inst.installment_number}</td>
        <td>${formatDate(inst.due_date)}</td>
        <td class="text-right">${formatCurrency(inst.amount)}</td>
        <td class="status">${inst.status || "Pending"}</td>
      </tr>`
    )
    .join("");

  const html = `
  <html>
    <head>
      <title>Draft Installment Plan</title>
      <style>
        @page { margin: 16mm; }
        body { font-family: Arial, sans-serif; color: #0f172a; }
        .card { border: 1px solid #0ea5e9; border-radius: 12px; padding: 20px; }
        .header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; }
        .title { font-size: 22px; font-weight: 700; color: #0ea5e9; }
        .meta { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px 14px; font-size: 13px; color: #1f2937; margin-bottom: 12px; }
        .meta strong { color: #0f172a; }
        table { width: 100%; border-collapse: collapse; margin-top: 10px; }
        thead { background: #0f172a; color: #e0f2fe; }
        th, td { padding: 10px 12px; border-bottom: 1px solid #cbd5e1; font-size: 13px; }
        .text-right { text-align: right; }
        .status { text-align: center; }
        .total-row td { font-weight: 700; background: #e0f2fe; color: #0f172a; }
      </style>
    </head>
    <body>
      <div class="card">
        <div class="header">
          <div class="title">Draft Installment Plan</div>
          <div style="font-size:12px;color:#475569;">Generated: ${formatDate(new Date())}</div>
        </div>
        <div class="meta">
          <div><strong>Plot #:</strong> ${summary.plotNumber || "-"}</div>
          <div><strong>Booking Date:</strong> ${summary.bookingDate || "-"}</div>
          <div><strong>Plot Size:</strong> ${summary.plotSize || "-"}</div>
          <div><strong>Total Price:</strong> ${formatCurrency(summary.totalPrice)}</div>
          <div><strong>Initial Payment:</strong> ${formatCurrency(summary.initialPayment)}</div>
        </div>
        <table>
          <thead>
            <tr>
              <th style="width:10%;">#</th>
              <th style="width:30%;">Due Date</th>
              <th style="width:30%;" class="text-right">Amount</th>
              <th style="width:30%;">Status</th>
            </tr>
          </thead>
          <tbody>
            ${rows}
            <tr class="total-row">
              <td colspan="2" class="text-right">Total:</td>
              <td class="text-right">${formatCurrency(totalAmount)}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </body>
  </html>
  `;

  const win = window.open("", "_blank", "width=900,height=700");
  if (!win) return;
  win.document.open();
  win.document.write(html);
  win.document.close();
  win.focus();
  win.print();
};

export default openInstallmentPlanPrint;

